import { type CoreInquiry } from '@flecto/types'

export function useStoreOrderId(order?: CoreInquiry) {
  if (!order) {
    return ''
  }

  return `#ST${order?.internal_id}`
}
